import PrivateRoute from 'Components/PrivateRoute';
import EquipmentTable from 'Pages/Equipment/Table';
import EquipmentCategoriesTable from 'Pages/EquipmentCategories/Table';
import ShowIndicator from 'Pages/Indicators/Show';
import MapPage from 'Pages/Map';
import SitesPage from 'Pages/SitesPage';
import TemplatesTable from 'Pages/Templates/Table';
import TreePage from 'Pages/Tree';
import UsersTable from 'Pages/Users/Table';
import WiseBoxDevicesTable from 'Pages/WiseBoxDevices/Table';
import WiseBoxesTable from 'Pages/WiseBoxes/Table';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router';

const Component = () => (
    <Routes>
        <Route element={<PrivateRoute/>}>
            <Route element={<MapPage/>} path="/map"/>
            <Route element={<SitesPage/>} path="/sites"/>
            <Route element={<ShowIndicator/>} path="/indicators/:indicatorId"/>
            <Route element={<TreePage/>} path="/sites/:siteId/:section?"/>
            <Route element={<TreePage/>} path="/devices/:deviceId/:section?"/>
            <Route element={<EquipmentTable/>} path="/equipment"/>
            <Route element={<EquipmentCategoriesTable/>} path="/equipment_categories"/>
            <Route element={<TemplatesTable/>} path="/templates"/>
            <Route element={<WiseBoxesTable/>} path="/unclaimed"/>
            <Route element={<WiseBoxDevicesTable/>} path="/wise_boxes"/>
            <Route element={<UsersTable/>} path="/users"/>
            <Route element={<Navigate replace to="/map"/>} path="*"/>
        </Route>
    </Routes>
);

export default Component;
